<script>
export default {
  name: 'AdminDirectoryHighlight',

  functional: true,

  props: {
    text: {
      default: ''
    },

    search: {
      type: String,
      default: ''
    },

    normalize: {
      type: String,
      default: ''
    }
  },

  render(createElement, { props }) {
    const text = String(props.text == null ? '' : props.text);
    const search = props.search.trim().toLowerCase();

    if (!search) {
      return createElement('span', text);
    }

    const matchRanges = [];

    // Collect matching ranges using an exclusive end position.
    // For normalized text, map positions back to the original text.
    const collectMatches = (searchableText, searchTerm, originalPositions) => {
      if (!searchTerm) {
        return;
      }

      let matchIndex = searchableText.indexOf(searchTerm);

      while (matchIndex !== -1) {
        const matchEnd = matchIndex + searchTerm.length;

        const start = originalPositions
            ? originalPositions[matchIndex]
            : matchIndex;

        const end = originalPositions
            ? originalPositions[matchEnd - 1] + 1
            : matchEnd;

        matchRanges.push([start, end]);

        matchIndex = searchableText.indexOf(searchTerm, matchEnd);
      }
    };

    // Match the text directly, ignoring case.
    collectMatches(text.toLowerCase(), search);

    // Also match phone numbers or license numbers without punctuation.
    if (props.normalize) {
      const isPhone = props.normalize === 'phone';
      const allowedCharacter = isPhone ? /[0-9]/ : /[a-z0-9]/;

      const originalPositions = [];
      let normalizedText = '';

      for (let index = 0; index < text.length; index += 1) {
        const character = text[index].toLowerCase();

        if (allowedCharacter.test(character)) {
          normalizedText += character;
          originalPositions.push(index);
        }
      }

      const normalizedSearch = [...search]
          .filter(character => allowedCharacter.test(character))
          .join('');

      // Require at least three digits for normalized phone matching.
      if (!isPhone || normalizedSearch.length >= 3) {
        collectMatches(
            normalizedText,
            normalizedSearch,
            originalPositions
        );
      }
    }

    // Combine overlapping or adjacent matches into a single highlight.
    matchRanges.sort((first, second) => first[0] - second[0]);

    const mergedRanges = [];

    matchRanges.forEach(([start, end]) => {
      const previousRange = mergedRanges[mergedRanges.length - 1];

      if (previousRange && start <= previousRange[1]) {
        previousRange[1] = Math.max(previousRange[1], end);
      } else {
        mergedRanges.push([start, end]);
      }
    });

    // Render text nodes, never HTML: contact values and search are untrusted.
    const nodes = [];
    let previousEnd = 0;

    mergedRanges.forEach(([start, end]) => {
      nodes.push(text.slice(previousEnd, start));

      nodes.push(
          createElement(
              'mark',
              { class: 'directory-search-match' },
              text.slice(start, end)
          )
      );

      previousEnd = end;
    });

    nodes.push(text.slice(previousEnd));

    return createElement('span', nodes);
  }
};
</script>

<style scoped>
.directory-search-match {
  padding: 0;
  color: inherit;
  background: #fff0a6;
  border-radius: 2px;
}
</style>